module.exports = __webpack_public_path__ + "img/ic_flat_gem.ab0dc3cd.png";